<template>
  <v-dialog
    v-model="stateData"
    @click:outside="() => cancel()"
    :max-width="widthData!=='full' ? parseInt(widthData) : null"
    :fullscreen="widthData==='full'"
    style="overflow: visible !important;"
  >
    <v-card :style="widthData==='full' ? 'border-radius: 0 !important; border: 0 !important;background:rgba(255, 255, 255, 0.9)' : 'background:rgba(255, 255, 255, 0.9) ; overflow: visible !important;'">
      <v-toolbar
        dark
        style="border-radius: 0 ; border: 0 !important;"
        color="#192a56"
        v-if="widthData==='full'"
      >
        <v-toolbar-title>
          <v-card-title class="white--text">
            {{titleData}}
          </v-card-title>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            left
            dark
            outlined
            color="white"
            class="mt-3"
            @click="() => cancel()"
          >
            خروج
            <v-icon>{{ mdiClose }}</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <page-render
          :widgets="widgets"
          :editOrShowTarget="editOrShowTarget"
          :paramId="paramId"
          :requestApiUrl="requestApiUrl"
          @n-dialog-send-dialog-id="nDialogSendDialogId"
          @close-dialog="cancel"
        />
      </v-card-text>
      <!--<v-card-actions v-if="widthData!=='full'">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text

        >
          بستن
        </v-btn>
      </v-card-actions>-->
      <v-btn
        absolute
        top
        left
        class="mt-0 ml-n8"
        fab
        dark
        style="border: 3px solid rgba(255,255,255,0.8) !important;display: none"
        x-small
        @click="() => cancel()"
        color="error"
      >
        <v-icon dark>
          {{ mdiClose }}
        </v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>

import axios from "@axios";
import {
  formConfig,
  initialSidebarsSize,
  tableDateHandler,
  tablePaginationHandler
} from "@/views/generator/page-handler";
import {mdiClose} from "@mdi/js";

export default {
  name: "n-dialog",
  components: {PageRender: () => import('@/views/generator/page-render')},
  props: {
    // eslint-disable-next-line vue/require-default-prop
    state: Boolean,
    id: String,
    width: String,
    widgets: Array,
    title: String,
    editOrShowTarget: String,
    paramId: String,
    requestApiUrl: String,

  },
  data() {
    return {
      mdiClose: mdiClose,
      widthData: this.width,
      stateData: this.state,
      widgetsData: this.widgets, // Initial value
      titleData: this.title, // Initial value
      pagination: [],
      paginationToQueryString: "?",
      deleteUrl: "",
    }
  },
  watch: {
    state(newValue) {
      this.stateData = newValue // Update when the prop changes
    },
    nestedDialogId(newValue) {
      console.log("here value",newValue)
      this.nestedDialogIdData = newValue // Update when the prop changes
    },
    widgets(newValue) {
      this.widgetsData = newValue // Update when the prop changes
    },
    title(newValue) {
      this.titleData = newValue // Update when the prop changes
    }
  },
  mounted() {
    this.initing()
  },
  methods: {
    nDialogSendDialogId(dialog){
      this.$emit("close-dialog",dialog);
    },
    cancel() {
      console.log("hee")
      this.widgetsData = null
      this.stateData = false
      this.$emit('close-dialog', this.id)
    },
    //dynamic ddl from request here
    initing(){
      this.widgetsData = formConfig(this.widgetsData)
      this.widgetsData = tableDateHandler(this.widgetsData)
    }
  }
}
</script>

<style>
.v-dialog--active{
  overflow: visible !important;
}
</style>
